import { useUser } from '@/components/AuthInterceptorComponent/hooks/useUser';
import { lazyRetry } from '@/utils/general';
import { Box } from '@mui/material';
import { lazy } from 'react';
import { userPhotoStyles } from './UserPhoto.styles';

const Image = lazy(() =>
  lazyRetry(() => import('../../../../components/Image')),
);

const getInitials = (firstName?: string, lastName?: string): string => {
  const first = firstName?.charAt(0)?.toUpperCase() ?? '';
  const last = lastName?.charAt(0)?.toUpperCase() ?? '';
  return `${first}${last}` || '?';
};

type UserPhotoProps = {
  onClick?: () => void;
  size?: 'small' | 'medium';
};

export const UserPhoto = ({ onClick, size = 'medium' }: UserPhotoProps) => {
  const { user } = useUser();
  const { classes, cx } = userPhotoStyles();
  const initials = getInitials(user?.first_name, user?.last_name);
  const photo = user?.profile?.photo;

  const handleOnClick = () => onClick?.();

  return (
    <Box className={classes.photoRoot} onClick={handleOnClick}>
      {photo ? (
        <Box className={classes.photoContainer}>
          <Box className={classes.photoInner}>
            <Image
              route={photo}
              alt="image-hacku"
              isStatic={!photo}
              blur
              shadow
            />
          </Box>
        </Box>
      ) : (
        <Box
          className={cx(
            classes.avatar,
            size === 'small' ? classes.avatarSmall : classes.avatarMedium,
          )}
        >
          {initials}
        </Box>
      )}
    </Box>
  );
};
